<template>
  <span
    class="chatbot-datetime"
    v-bind:class="{ 'chatbot-datetime-sticky': stickDates }"
  >
    {{ formattedDate }}
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    date: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("messages", ["stickDates"]),
    formattedDate() {
      return this.date
        .clone()
        .locale("pt-br")
        .calendar(null, {
          sameDay: "[Hoje]",
          lastDay: "[Ontem]",
          lastWeek: "dddd",
          sameElse: "DD/MM/YYYY"
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.chatbot-datetime {
  display: block;
  width: fit-content;
  min-width: 120px;
  position: relative;
  background-color: #ced7de;
  color: #555555;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 0.9rem;

  &.chatbot-datetime-sticky {
    position: sticky;
    top: 10px;
    z-index: 1;
  }
}
</style>
